module.exports = __webpack_public_path__ + "fonts/SofiaProBlack-Italic.543a00ba.ttf";